import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IBankModel } from "src/app/components/form-fields/bank-details/bank-model";
import { IBranchContactsModel } from "src/app/components/master-data/branch-contact/branch-contact-model";
import { IBranchInternalContactsModel } from "src/app/components/master-data/branch-internal-contact/branch-internal-contact-model";
import { BackendListModel } from "src/app/models/common/list.model";
import { ICompanyGroupModel } from "src/app/models/customer_master_model/company-group-model";
import { ICompanyModel } from "src/app/models/customer_master_model/company-model";
import { CompanyTypeModel } from "src/app/models/customer_master_model/company-type-model";
import { TaxIdentifierModel } from "src/app/models/customer_master_model/tax-identifier-model";
// import { ITax_Identifiers } from "src/app/models/customer_master_model/tax-identifiers";
import { ApiRoutes } from "../apiroutes";

@Injectable({
  providedIn: 'root'
})

export class CompanyApiService {
  base_url = ApiRoutes.Company;

  constructor(private http: HttpClient) { }

  // GET Companies
  getCompany(page_size = 10, page = 1, search = '', order = ''): Observable<BackendListModel<ICompanyModel>> {
    let url = `${this.base_url}company/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('page_size', String(page_size));
    urlObj.searchParams.append('page', String(page));
    urlObj.searchParams.append('search', String(search));
    urlObj.searchParams.append('o', String(order));

    return this.http.get<BackendListModel<ICompanyModel>>(String(urlObj));
  }

  // GET Company by ID
  getCompanyById(id: any): Observable<ICompanyModel> {
    let url = `${this.base_url}company/${id}/`;
    return this.http.get<ICompanyModel>(url);
  }

  // PUT | UPDATE Company
  updateCompany(companyId, company: ICompanyModel) {
    let url = `${this.base_url}company/${companyId}/`;
    return this.http.put<ICompanyModel>(url, company);
  }

  // Patch Company
  patchCompany(companyId, data) {
    let url = `${this.base_url}company/${companyId}/`;
    return this.http.patch(url, data);
  }

  // GET Tax Identifier By COUNTRY
  getTaxIdentifierByCountry(countryId: string, customerType:string='business'): Observable<BackendListModel<TaxIdentifierModel>> {
    let url = `${this.base_url}tax_identifier/`;
    let urlObj=new URL(url)
    if(countryId){
      urlObj.searchParams.append('country', countryId);
    }
    urlObj.searchParams.append('customer_type', customerType);

    return this.http.get<BackendListModel<TaxIdentifierModel>>(String(urlObj));
  }

  // POST tax identifier to get company details
  getCompanyDetailsByTaxIdentifier(data): Observable<any> {
    let url = `${this.base_url}tax_identifier/autocomplete/`;
    return this.http.post<any>(url, data)
  }

  getGroups(): Observable<BackendListModel<ICompanyGroupModel>> {
    let url = `${this.base_url}group/`;
    return this.http.get<BackendListModel<ICompanyGroupModel>>(url);
  }

  getCompanyTypeList(): Observable<BackendListModel<CompanyTypeModel>> {
    let url = `${this.base_url}company_type/`;
    return this.http.get<BackendListModel<CompanyTypeModel>>(url);
  }

  // POST Company
  postCompany(company: ICompanyModel) {
    let url = `${this.base_url}company/`;
    return this.http.post<ICompanyModel>(url, company);
  }

  // POST Company Branch
  postBranch(branch) {
    let url = `${this.base_url}branch/`;
    return this.http.post(url, branch);
  }

  postMultipleBranch(branchData) {
    let url = `${this.base_url}create_multiple_branches/`;
    return this.http.post<any[]>(url, branchData);
  }

  // PUT Company Branch
  putBranch(branch, branchId) {
    let url = `${this.base_url}branch/${branchId}/`;
    return this.http.put(url, branch);
  }

  // Branch Contacts
  getBranchContact(companyId): Observable<BackendListModel<IBranchContactsModel>> {
    let url = `${this.base_url}branch_contacts/?company_id=${companyId}`;
    return this.http.get<BackendListModel<IBranchContactsModel>>(url)
  }

  getBranchContactById(id): Observable<BackendListModel<IBranchContactsModel>> {
    let url = `${this.base_url}branch_contacts/${id}/`;
    return this.http.get<BackendListModel<IBranchContactsModel>>(url)
  }

  postBranchContact(data: IBranchContactsModel) {
    let url = `${this.base_url}branch_contacts/`;
    return this.http.post<IBranchContactsModel>(url, data)
  }

  updateBranchContact(id, data: IBranchContactsModel) {
    let url = `${this.base_url}branch_contacts/${id}/`;
    return this.http.put<IBranchContactsModel>(url, data)
  }

  // Branch Internal Contacts
  getBranchInternalContact(companyId): Observable<BackendListModel<IBranchInternalContactsModel>> {
    let url = `${this.base_url}branch_internal_contacts/?company_id=${companyId}`;
    return this.http.get<BackendListModel<IBranchInternalContactsModel>>(url)
  }

  getBranchInternalContactById(id): Observable<BackendListModel<IBranchInternalContactsModel>> {
    let url = `${this.base_url}branch_internal_contacts/${id}/`;
    return this.http.get<BackendListModel<IBranchInternalContactsModel>>(url)
  }

  postBranchInternalContact(data: IBranchInternalContactsModel) {
    let url = `${this.base_url}branch_internal_contacts/`;
    return this.http.post<IBranchContactsModel>(url, data)
  }

  updateBranchInternalContact(id, data: IBranchInternalContactsModel) {
    let url = `${this.base_url}branch_internal_contacts/${id}/`;
    return this.http.put<IBranchContactsModel>(url, data)
  }

  // Company profile kyc api
  postUserTaxIdentifierItem(data, comapnyId) {
    let url = `${this.base_url}user_tax_identifiers_for_company/${comapnyId}/`;
    return this.http.post(url, data)
  }

  putUserTaxIdentifierItem(data, id) {
    let url = `${this.base_url}user_tax_identifier/${id}/`;
    return this.http.put(url, data)
  }

  // Tax Identifier
  postUserTaxIdentifier(data) {
    let url = `${this.base_url}bulk_user_tax_identifier/`;
    return this.http.post(url, data)
  }

  // Bank Details
  getBankDetails(): Observable<BackendListModel<IBankModel>> {
    let url = `${this.base_url}bank_details/`;
    return this.http.get<BackendListModel<IBankModel>>(url)
  }

  getBankDetailsById(id): Observable<BackendListModel<IBankModel>> {
    let url = `${this.base_url}bank_details/${id}/`;
    return this.http.get<BackendListModel<IBankModel>>(url)
  }

  getBankDetailsByCompanyId(companyId): Observable<BackendListModel<IBankModel>> {
    let url = `${this.base_url}bank_details/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('company_id', String(companyId));
    return this.http.get<BackendListModel<IBankModel>>(String(urlObj))
  }

  postBankDetails(data: IBankModel) {
    let url = `${this.base_url}bank_details/`;
    return this.http.post(url, data)
  }

  updateBankDetails(id, data: IBankModel) {
    let url = `${this.base_url}bank_details/${id}/`;
    return this.http.put(url, data)
  }

  putAgreementDetails(id, data) {
    let url = `${this.base_url}master_agreement/${id}/`;
    return this.http.put(url, data)
  }

  submitKycForCompanyProfile() {
    let url = `${this.base_url}send_kyc_approval_mail/`;
    return this.http.post(url, {})
  }

  getCompanyForKyc(id) {
    let url = `${this.base_url}company_kyc/${id}/`;
    return this.http.get(url);
  }

  downloadKycDoc(download_url) {
    // let url = `${this.baseUrl}${report_id}/download/`;
    return this.http.get(download_url, { responseType: 'blob' });
  }
}
